/**
 * Internal helper: two-digit zero-pad.
 * @param {number} n
 * @returns {string}
 */
export const pad = (n) => n.toString().padStart(2, '0');
